import locationOffenseModelValidator from 'forms/shared/validators/models/location/models/offense';
import { DEFAULT_EARLIEST, DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { getSafeDateTime, setToStartOfMonth } from 'helpers/date';
import { isPVQForm } from 'helpers/form';
import { REQUIRED } from 'constants/errors';
import { DeepSafePartial } from 'types/types';
import { LocationModel } from 'forms/shared/types';
import { domesticOrderOptions } from 'constants/enums/legalOptions';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import { isSafeUnitedStates } from 'helpers/locations';
import { DateTime } from 'luxon';
import { LegalPoliceDomesticViolenceItemModel } from '../types';

export const legalPoliceDomesticViolenceItemValidator: ValidateJSModel<LegalPoliceDomesticViolenceItemModel> = {
  CourtAddress: (value: DeepSafePartial<LocationModel>, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        location: {
          requireStreet: isSafeUnitedStates(value),
          validator: pvqLocationModelValidator,
        },
        presence: true,
      };
    }

    return {
      presence: true,
      location: {
        validator: locationOffenseModelValidator,
        requireCity: value ? !value.county : true,
        requireCounty: value ? !value.city : true,
      },
    };
  },
  CourtName: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    return { presence: true, hasValue: true };
  },
  Explanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (attributes?.ProtectedParty?.values?.includes?.('Other')) {
        return { presence: true, hasValue: true };
      }

      return {};
    }

    return { presence: true, hasValue: true };
  },
  // Validation is the same for both PVQ and non-PVQ
  Issued: (value, attributes, attributeName, options) => ({
    presence: true,
    /* Added to display error: The date should be after your date of birth. */
    date: {
      requireDay: false,
      earliest: getSafeDateTime(setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST) as DateTime).datetime,
      latest: DEFAULT_LATEST,
      tooEarly: 'error.date.min',
    },
  }),
  ProtectedParty: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        array: {
          validator: {
            inclusion: domesticOrderOptions,
            presence: true,
          },
          length: { minimum: 1, message: REQUIRED },
        },
      };
    }
    return {};
  },
  OrderExpiration: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        /* Added to display error: The date should be after your date of birth. */
        date: {
          requireDay: false,
          earliest: getSafeDateTime(setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST) as DateTime).datetime,
          tooEarly: 'error.date.min',
        },
      };
    }
    return {};
  },
  OrderIssuedReason: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        hasValue: true,
      };
    }
    return {};
  },
};
